import { svgDataUri } from '../shared'
import iconUserCat from './user-icons/cat.png'
import iconUserHorse from './user-icons/horse.png'
import iconUserGuineaPig from './user-icons/guinea_pig.png'
import iconUserPoodleGlasses from './user-icons/poodle_glasses.png'
import iconUserCatFold from './user-icons/cat_fold.png'

export const ICON_USER = svgDataUri(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><circle cx="12" cy="8" r="4" fill="#7B8CAA"/><path d="M4 21 C4 15.5 7.5 13 12 13 C16.5 13 20 15.5 20 21 Z" fill="#7B8CAA"/></svg>'
)

export const demoUser = {
  uuid: 'demo-user-uuid',
  lockVersion: 1,
  name: '塩崎 一郎',
  code: 'demo-user',
  email: 'demo-user@example.com',
  iconUrl: iconUserCat,
  lastLoginAt: 0,
  lastLogoutAt: 0,
}

// demoUser以外にもユーザーを用意し、ユーザー画面やProjectMember画面の
// ユーザーピッカーに複数の選択肢を持たせる。追加・編集・削除の保存が
// 空っぽの状態ではなく実際の操作らしく見えるようにするため。
export const baseUserDetail = {
  lockVersion: 1,
  revision: 'demo-revision',
  children: [] as any[],
  nameKana: '',
  nameAlphabet: '',
  phoneNumber: '',
  birthday: '',
  division: undefined,
  position: undefined,
  hireDate: '',
  leaveDate: '',
  validFrom: 0,
  validTo: 0,
  emailNotification: false,
  role: { uuid: 'demo-role-member', code: 'MEMBER', name: 'メンバー' },
  timezoneId: 'Asia/Tokyo',
  oneTimeTokenExpiredAt: 0,
  temporaryPasswordExpiredAt: 0,
  lastLoginAt: '',
  lastAccessAt: '',
  registrationStatus: 'FINAL',
  changingEmailStatus: 'FINAL',
  temporaryPasswordStatus: 'FINAL',
  partnerMember: false,
}

export const demoUsersByUuid: { [uuid: string]: any } = {
  [demoUser.uuid]: {
    ...baseUserDetail,
    uuid: demoUser.uuid,
    code: demoUser.code,
    name: demoUser.name,
    email: demoUser.email,
    iconUrl: demoUser.iconUrl,
    role: { uuid: 'demo-role-admin', code: 'ADMIN', name: '管理者' },
  },
  'demo-user-2': {
    ...baseUserDetail,
    uuid: 'demo-user-2',
    code: 'demo-user-2',
    name: '山田 太郎',
    email: 'yamada@example.com',
    iconUrl: iconUserHorse,
  },
  'demo-user-3': {
    ...baseUserDetail,
    uuid: 'demo-user-3',
    code: 'demo-user-3',
    name: '吉田 花子',
    email: 'yoshida@example.com',
    iconUrl: iconUserGuineaPig,
  },
  'demo-user-4': {
    ...baseUserDetail,
    uuid: 'demo-user-4',
    code: 'demo-user-4',
    name: '斎藤 健一',
    email: 'saito-kenichi@example.com',
    iconUrl: iconUserPoodleGlasses,
    role: { uuid: 'demo-role-admin', code: 'ADMIN', name: '管理者' },
  },
  'demo-user-5': {
    ...baseUserDetail,
    uuid: 'demo-user-5',
    code: 'demo-user-5',
    name: '伊藤 大輔',
    email: 'ito@example.com',
    iconUrl: iconUserCatFold,
  },
}

// Tenant.getDetail()（GET /api/v1/tenants/detail）のレスポンスであり、
// store.tenant.organization の中身でもある。デモは認証フローを通らず
// Auth.refreshOrganization() が呼ばれないため、useSeedDemoTenant.ts が
// これを直接 dispatch してstoreを埋める。両者で形がずれないよう1箇所に置く。
//
// aliasは 'demo'。タイマー機能（MyWbsItems/hooks/featureFlag.ts）は
// production かつ alias が特定テナントのときだけ有効になるため、配布する
// デモビルド（build:demo / build:demo-production。いずれも
// FLAGXS_ENV=production）ではこの値のまま無効になる。タイマーはstart/stopの
// APIをモックしておらず、実際に計測できて初めて意味を持つ機能なので、
// デモには出さない。
//
// ただしローカル（npm start / start:demo）はFLAGXS_ENV=developmentなので
// featureFlagの `!isProduction` 側が通り、aliasに関係なくタイマー列が出る。
// 配布物では出ないため実害は無いが、ローカルで見えても不具合ではない。
export const demoOrganizationDetail = {
  uuid: 'demo-tenant-uuid',
  lockVersion: 1,
  revision: 'demo-revision',
  alias: 'demo',
  displayName: 'デモテナント',
  officialName: 'デモテナント株式会社',
  iconUrl: '',
  defaultTimezoneId: 'Asia/Tokyo',
  defaultLanguage: 'ja',
  emailDomainWhitelist: '',
  skipEmailVerification: true,
  maintenanceMessage: '',
  dailyWorkHours: 8,
  monthlyWorkDays: 20,
  financialYearEndMonth: '03',
  updatedBy: demoUser,
  updatedAt: new Date(0).toISOString(),
}
